"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColor = exports.OPACITY = exports.COLORS = exports.COLOR_DICTIONARY = void 0;
const utils_enums_segments_1 = require("@gcloud-npm/utils.enums.segments");
/* PRINCIPALES */
const BLUE_MOVISTAR = "BLUE_MOVISTAR";
const BLUE = "BLUE";
const BLUEA = "BLUE_A";
const BLUEB = "BLUE_B";
const BLUE_A = "BLUE_A";
const BLUE_B = "BLUE_B";
const BLUE_DARK = "BLUE_DARK";
const BLUE_BF = "BLUE_BF";
const BLUE_TELEFONICA = "BLUE_TELEFONICA";
const BLUE_ORION = "BLUE_ORION";
const WHITE = "WHITE";
const BLACK = "BLACK";
/* GREY */
const GREY = "GREY";
const GREY1 = "GREY1";
const GREY2 = "GREY2";
const GREY3 = "GREY3";
const GREY4 = "GREY4";
const GREY5 = "GREY5";
const GREY6 = "GREY6";
/* SECUNDARIOS (*USO EXCEPCIONAL*) */
const PURPLE = "PURPLE";
const GREEN = "GREEN";
const GREEN_CUSTO = "GREEN_CUSTO";
const ORANGE = "ORANGE";
const RED = "RED";
const RED_DARK = "RED_DARK";
const RED_BRIGHT = "RED_BRIGHT";
/* MOVISTAR PLUS */
const YELLOW_PLUS = "YELLOW_PLUS";
const GREEN_PLUS = "GREEN_PLUS";
const PURPLE_PLUS = "PURPLE_PLUS";
const PINK_PLUS = "PINK_PLUS";
const TRANSPARENT = "TRANSPARENT";
const INHERIT = "INHERIT";
/* PROSEGUR */
const YELLOW_PROSEGUR = "YELLOW_PROSEGUR";
const GREY_PROSEGUR = "GREY_PROSEGUR";
exports.COLOR_DICTIONARY = {
    BLUE_MOVISTAR,
    BLUE,
    BLUEA,
    BLUEB,
    BLUE_A,
    BLUE_B,
    BLUE_BF,
    BLUE_DARK,
    BLUE_TELEFONICA,
    BLUE_ORION,
    WHITE,
    BLACK,
    GREY,
    GREY1,
    GREY2,
    GREY3,
    GREY4,
    GREY5,
    GREY6,
    GREY_PROSEGUR,
    PURPLE,
    GREEN,
    GREEN_CUSTO,
    ORANGE,
    RED,
    RED_DARK,
    RED_BRIGHT,
    YELLOW_PLUS,
    YELLOW_PROSEGUR,
    GREEN_PLUS,
    PURPLE_PLUS,
    PINK_PLUS,
    TRANSPARENT,
    INHERIT,
};
exports.COLORS = {
    gp: {
        [exports.COLOR_DICTIONARY.BLUE_MOVISTAR]: "#019DF4",
        [exports.COLOR_DICTIONARY.BLUE]: "#0079BB",
        [exports.COLOR_DICTIONARY.BLUEA]: "#0079BB",
        [exports.COLOR_DICTIONARY.BLUEB]: "#414861",
        [exports.COLOR_DICTIONARY.BLUE_DARK]: "#0B2739",
        [exports.COLOR_DICTIONARY.BLUE_TELEFONICA]: "#0066FF",
        [exports.COLOR_DICTIONARY.BLUE_ORION]: "#4e73df",
        [exports.COLOR_DICTIONARY.BLUE_BF]: "#009ff7",
        [exports.COLOR_DICTIONARY.WHITE]: "#ffffff",
        [exports.COLOR_DICTIONARY.BLACK]: "#000000",
        [exports.COLOR_DICTIONARY.GREY]: "#2A2A3C",
        [exports.COLOR_DICTIONARY.GREY1]: "#F5F5F5",
        [exports.COLOR_DICTIONARY.GREY2]: "#EEEEEE",
        [exports.COLOR_DICTIONARY.GREY3]: "#DDDDDD",
        [exports.COLOR_DICTIONARY.GREY4]: "#999999",
        [exports.COLOR_DICTIONARY.GREY5]: "#6B6C6F",
        [exports.COLOR_DICTIONARY.GREY6]: "#313235",
        [exports.COLOR_DICTIONARY.GREY_PROSEGUR]: "#3A3C3F",
        [exports.COLOR_DICTIONARY.PURPLE]: "#A13EA1",
        [exports.COLOR_DICTIONARY.GREEN]: "#5CB615",
        [exports.COLOR_DICTIONARY.GREEN_CUSTO]: "#209e91",
        [exports.COLOR_DICTIONARY.ORANGE]: "#F28D15",
        [exports.COLOR_DICTIONARY.RED]: "#FF374A",
        [exports.COLOR_DICTIONARY.RED_DARK]: "#B22634",
        [exports.COLOR_DICTIONARY.RED_BRIGHT]: "#EF3C3C",
        [exports.COLOR_DICTIONARY.YELLOW_PROSEGUR]: "#FFD102",
        [exports.COLOR_DICTIONARY.TRANSPARENT]: "transparent",
        [exports.COLOR_DICTIONARY.INHERIT]: "inherit",
    },
    emp: {
        [exports.COLOR_DICTIONARY.BLUE]: "#0066FF",
        [exports.COLOR_DICTIONARY.BLUE_DARK]: "#0B2739",
        [exports.COLOR_DICTIONARY.BLUE_BF]: "#009ff7",
        [exports.COLOR_DICTIONARY.WHITE]: "#FFFFFF",
        [exports.COLOR_DICTIONARY.BLACK]: "#000000",
        [exports.COLOR_DICTIONARY.GREY]: "#2A2A3C",
        [exports.COLOR_DICTIONARY.GREY1]: "#F2F4FF",
        [exports.COLOR_DICTIONARY.GREY2]: "#D1D5E4",
        [exports.COLOR_DICTIONARY.GREY3]: "#B0B6CA",
        [exports.COLOR_DICTIONARY.GREY4]: "#8F97AF",
        [exports.COLOR_DICTIONARY.GREY5]: "#6E7894",
        [exports.COLOR_DICTIONARY.GREY6]: "#58617A",
        [exports.COLOR_DICTIONARY.PURPLE]: "#A13EA1",
        [exports.COLOR_DICTIONARY.GREEN]: "#00B981",
        [exports.COLOR_DICTIONARY.GREEN_CUSTO]: "#209e91",
        [exports.COLOR_DICTIONARY.ORANGE]: "#EC624B",
        [exports.COLOR_DICTIONARY.RED]: "#D23C31",
        [exports.COLOR_DICTIONARY.RED_DARK]: "#B22634",
        [exports.COLOR_DICTIONARY.RED_BRIGHT]: "#EF3C3C",
        [exports.COLOR_DICTIONARY.TRANSPARENT]: "transparent",
        [exports.COLOR_DICTIONARY.INHERIT]: "inherit",
    },
    plus: {
        [exports.COLOR_DICTIONARY.YELLOW_PLUS]: "#F2B820",
        [exports.COLOR_DICTIONARY.GREEN_PLUS]: "#A9CF38",
        [exports.COLOR_DICTIONARY.PURPLE_PLUS]: "#7350CD",
        [exports.COLOR_DICTIONARY.PINK_PLUS]: "#F03C87",
        [exports.COLOR_DICTIONARY.TRANSPARENT]: "transparent",
        [exports.COLOR_DICTIONARY.INHERIT]: "inherit",
    },
};
exports.OPACITY = {
    "00": "00",
    10: "1A",
    20: "33",
    30: "4D",
    40: "66",
    50: "80",
    60: "99",
    70: "B3",
    80: "CC",
    90: "E6",
    100: "FF",
};
const getColor = (colorId, opacity = "", segment = `${process.env.NEXT_PUBLIC_ENV_SEGMENT}`) => {
    if (colorId) {
        const colorIdMayus = colorId.toUpperCase();
        const mySegmentNormalized = (0, utils_enums_segments_1.getNormalizedSegment)(segment);
        if (colorIdMayus &&
            exports.COLORS[mySegmentNormalized] &&
            exports.COLORS[mySegmentNormalized][colorIdMayus]) {
            const validOpacity = `${(colorIdMayus !== "TRANSPARENT" || colorIdMayus !== "INHERIT") &&
                opacity &&
                opacity !== "FF"
                ? opacity
                : ""}`;
            return `${exports.COLORS[mySegmentNormalized][colorIdMayus]}${validOpacity}`;
        }
    }
    return "#0B2739";
};
exports.getColor = getColor;
exports.default = exports.getColor;
//# sourceMappingURL=index.js.map